import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { get, getIn, List } from 'immutable';
export var VALIDATE_DB_ADAPTERS = [{
  label: 'Microsoft SQL Server',
  value: 'mssql'
}, {
  label: 'Oracle DB Server',
  value: 'oracle'
}, {
  label: 'PostgreSQL DB Server',
  value: 'postgres'
}];

var getValueFromList = function getValueFromList(properties, key, initialValue) {
  var property = properties.find(function (p) {
    return p.get('name') === key;
  });
  return property ? property.get('value') : initialValue;
};

export var generateInitialValues = function generateInitialValues(persistedObject, persistedPath, defaultObject, adapter) {
  return function (key) {
    var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var sameAsTenant = getIn(persistedObject, persistedPath.concat(['type']), '') === adapter;
    var defaultObjectValue = getValueFromList(get(defaultObject, 'properties', List()), key, initialValue);

    if (sameAsTenant) {
      // Get the properties from the persisted object.
      var properties = getIn(persistedObject, persistedPath.concat(['properties']), List());

      if (List.isList(properties)) {
        var property = properties.find(function (p) {
          return p.get('name') === key;
        });
        return property ? property.get('value') : defaultObjectValue;
      } else {
        return get(properties, key, defaultObjectValue);
      }
    } else if (get(defaultObject, 'type') === adapter) {
      var adapterProperty = get(defaultObject, 'properties', List()).find(function (property) {
        return property.get('name') === key;
      });
      return get(adapterProperty, 'value', defaultObjectValue);
    }

    return initialValue;
  };
};

var generatePasswordFields = function generatePasswordFields(adapterName, persistedObject, currentAdapter, defaultAdapter) {
  var label = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'Password';
  var fieldName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'password';
  var additionalValidation = arguments.length > 6 ? arguments[6] : undefined;

  var required = function required(_ref) {
    var values = _ref.values;
    var currentAdapterName = values.get(currentAdapter); // If this adapter is the same as the currently chosen adapter.

    if (currentAdapterName === adapterName) {
      // And we are editing an existing adaptedr, it is required if changing.
      if (persistedObject) {
        return values.get("".concat(adapterName, "_").concat(fieldName, "Change")); // Otherwise it's only required, when editing, if the adapter is different than the default.
      } else if (typeof additionalValidation === 'function') {
        return additionalValidation(values);
      } else {
        return getIn(defaultAdapter, ['type'], '') !== adapterName;
      }
    }

    return false;
  };

  var name = "".concat(adapterName, "_").concat(fieldName);
  return [{
    name: name,
    label: label,
    type: 'password',
    "transient": function transient(_ref2) {
      var values = _ref2.values;
      return persistedObject ? !values.get("".concat(name, "Change")) : values.get(name) === '';
    },
    required: required,
    visible: function visible(_ref3) {
      var values = _ref3.values;
      return values.get("".concat(name, "Change"));
    }
  }, {
    name: "".concat(name, "Change"),
    label: "Change ".concat(label),
    type: 'checkbox',
    visible: !!persistedObject,
    initialValue: !persistedObject,
    "transient": true,
    onChange: function onChange(_ref4, _ref5) {
      var values = _ref4.values;
      var setValue = _ref5.setValue;

      if (values.get("".concat(name)) !== '') {
        setValue("".concat(name), '');
      }
    }
  }];
};

export var MSSQL_FIELDS = function MSSQL_FIELDS(adapter, persistedObject, persistedPath, defaultAdapter) {
  var trueIfAdapter = function trueIfAdapter(_ref6) {
    var values = _ref6.values;
    return values.get(adapter) === 'mssql';
  };

  var initialValues = generateInitialValues(persistedObject, persistedPath, defaultAdapter, 'mssql');
  return [{
    name: 'mssql_host',
    label: 'Host',
    type: 'text',
    required: trueIfAdapter,
    visible: trueIfAdapter,
    initialValue: initialValues('host', '127.0.0.1')
  }, {
    name: 'mssql_port',
    label: 'Port',
    type: 'text',
    required: trueIfAdapter,
    visible: trueIfAdapter,
    initialValue: initialValues('port', '1433')
  }, {
    name: 'mssql_database',
    label: 'Database',
    type: 'text',
    required: trueIfAdapter,
    visible: trueIfAdapter,
    initialValue: initialValues('database', '')
  }, {
    name: 'mssql_instance',
    label: 'Instance',
    type: 'text',
    required: false,
    visible: trueIfAdapter,
    initialValue: initialValues('instance', '')
  }, {
    name: 'mssql_username',
    label: 'Username',
    type: 'text',
    required: false,
    visible: trueIfAdapter,
    initialValue: initialValues('username', '')
  }].concat(_toConsumableArray(generatePasswordFields('mssql', persistedObject, adapter, defaultAdapter, 'Password', 'password')), [{
    name: 'mssql_sslEnabled',
    label: 'Enable SSL',
    type: 'select',
    required: false,
    visible: trueIfAdapter,
    options: [{
      label: 'True',
      value: 'true'
    }, {
      label: 'False',
      value: 'false'
    }],
    initialValue: initialValues('sslEnabled', 'false')
  }, {
    name: 'mssql_sslProtocol',
    description: 'Protocol to use with SSL encryption',
    label: 'SSL Protocol',
    type: 'text',
    required: false,
    visible: trueIfAdapter,
    initialValue: initialValues('sslProtocol', 'TLSv1.2')
  }, {
    name: 'mssql_sslrootcert',
    label: 'Root Certificate',
    type: 'text-area',
    required: false,
    visible: trueIfAdapter,
    initialValue: initialValues('sslrootcert', '')
  }, {
    name: 'mssql_sslcert',
    label: 'Client Certificate',
    type: 'text-area',
    required: false,
    visible: trueIfAdapter,
    initialValue: initialValues('sslcert', '')
  }], _toConsumableArray(generatePasswordFields('mssql', persistedObject, adapter, defaultAdapter, 'Truststore Password', 'ssltruststorepw', function (values) {
    return values.get('mssql_sslrootcert', '') !== '';
  })), _toConsumableArray(generatePasswordFields('mssql', persistedObject, adapter, defaultAdapter, 'Keystore Password', 'sslkeystorepw', function (values) {
    return values.get('mssql_sslcert', '') !== '';
  })));
};
export var ORACLE_FIELDS = function ORACLE_FIELDS(adapter, persistedObject, persistedPath, defaultAdapter) {
  var initialValues = generateInitialValues(persistedObject, persistedPath, defaultAdapter, 'oracle');

  var trueIfAdapter = function trueIfAdapter(_ref7) {
    var values = _ref7.values;
    return values.get(adapter) === 'oracle';
  };

  return [{
    name: 'oracle_host',
    label: 'Host',
    type: 'text',
    required: trueIfAdapter,
    visible: trueIfAdapter,
    initialValue: initialValues('host', '127.0.0.1')
  }, {
    name: 'oracle_port',
    label: 'Port',
    type: 'text',
    required: trueIfAdapter,
    visible: trueIfAdapter,
    initialValue: initialValues('port', '1521')
  }, {
    name: 'oracle_service',
    label: 'Service Name',
    type: 'text',
    required: trueIfAdapter,
    visible: trueIfAdapter,
    initialValue: initialValues('service', 'ORCLCDB')
  }, {
    name: 'oracle_username',
    label: 'Username',
    type: 'text',
    required: false,
    initialValue: initialValues('username', ''),
    visible: trueIfAdapter
  }].concat(_toConsumableArray(generatePasswordFields('oracle', persistedObject, adapter, defaultAdapter)), [{
    name: 'oracle_sslEnabled',
    label: 'Enable SSL',
    type: 'select',
    required: false,
    visible: trueIfAdapter,
    options: [{
      label: 'True',
      value: 'true'
    }, {
      label: 'False',
      value: 'false'
    }],
    initialValue: initialValues('sslEnabled', 'false')
  }, {
    name: 'oracle_sslVersion',
    label: 'TLS Version',
    type: 'text',
    required: false,
    visible: trueIfAdapter,
    initialValue: initialValues('sslVersion', '1.2')
  }, {
    name: 'oracle_sslServerDnMatch',
    label: 'Server DN Match',
    type: 'select',
    required: false,
    visible: trueIfAdapter,
    options: [{
      label: 'True',
      value: 'true'
    }, {
      label: 'False',
      value: 'false'
    }],
    initialValue: initialValues('sslServerDnMatch', 'false')
  }, {
    name: 'oracle_ciphersuites',
    label: 'Cipher Suites',
    type: 'text',
    required: false,
    visible: trueIfAdapter,
    initialValue: initialValues('ciphersuites', '')
  }, {
    name: 'oracle_serverCert',
    label: 'Server Certificate',
    type: 'text-area',
    required: false,
    visible: trueIfAdapter,
    initialValue: initialValues('serverCert', '')
  }, {
    name: 'oracle_clientCert',
    label: 'Client Certificate',
    type: 'text-area',
    required: false,
    visible: trueIfAdapter,
    initialValue: initialValues('clientCert', '')
  }], _toConsumableArray(generatePasswordFields('oracle', persistedObject, adapter, defaultAdapter, 'Truststore Password', 'truststorePassword', function (values) {
    return values.get('oracle_serverCert', '') !== '';
  })), _toConsumableArray(generatePasswordFields('oracle', persistedObject, adapter, defaultAdapter, 'Keystore Password', 'keystorePassword', function (values) {
    return values.get('oracle_clientCert', '') !== '';
  })));
};
export var POSTGRES_FIELDS = function POSTGRES_FIELDS(adapter, persistedObject, persistedPath, defaultAdapter) {
  var trueIfAdapter = function trueIfAdapter(_ref8) {
    var values = _ref8.values;
    return values.get(adapter) === 'postgres';
  };

  var initialValues = generateInitialValues(persistedObject, persistedPath, defaultAdapter, 'postgres');
  return [{
    name: 'postgres_host',
    label: 'Host',
    type: 'text',
    required: trueIfAdapter,
    visible: trueIfAdapter,
    initialValue: initialValues('host', '127.0.0.1')
  }, {
    name: 'postgres_port',
    label: 'Port',
    type: 'text',
    required: trueIfAdapter,
    visible: trueIfAdapter,
    initialValue: initialValues('port', '5432')
  }, {
    name: 'postgres_database',
    label: 'Database',
    type: 'text',
    required: trueIfAdapter,
    visible: trueIfAdapter,
    initialValue: initialValues('database', 'postgres')
  }, {
    name: 'postgres_username',
    label: 'Username',
    type: 'text',
    required: false,
    visible: trueIfAdapter,
    initialValue: initialValues('username', '')
  }].concat(_toConsumableArray(generatePasswordFields('postgres', persistedObject, adapter, defaultAdapter)), [{
    name: 'postgres_sslEnabled',
    label: 'Enable SSL',
    type: 'select',
    required: false,
    visible: trueIfAdapter,
    options: [{
      label: 'True',
      value: 'true'
    }, {
      label: 'False',
      value: 'false'
    }],
    initialValue: initialValues('sslEnabled', 'false')
  }, {
    name: 'postgres_sslmode',
    label: 'SSL Mode',
    type: 'select',
    required: false,
    visible: trueIfAdapter,
    options: [{
      label: 'Disable',
      value: 'disable'
    }, {
      label: 'Allow',
      value: 'allow'
    }, {
      label: 'Prefer',
      value: 'prefer'
    }, {
      label: 'Verify CA',
      value: 'verify-ca'
    }, {
      label: 'Verify Full',
      value: 'verify-full'
    }],
    initialValue: initialValues('sslmode', 'disable')
  }, {
    name: 'postgres_sslrootcert',
    description: 'x509 certificate (PEM format) used for server authentication',
    label: 'Root Certificate',
    type: 'text-area',
    required: false,
    visible: trueIfAdapter,
    initialValue: initialValues('sslrootcert', '')
  }, {
    name: 'postgres_sslcert',
    label: 'Client Certificate',
    type: 'text-area',
    required: false,
    visible: trueIfAdapter,
    initialValue: initialValues('sslcert', '')
  }, {
    name: 'postgres_sslkey',
    label: 'Client Key',
    type: 'text-area',
    required: false,
    visible: trueIfAdapter,
    initialValue: initialValues('sslkey', '')
  }]);
};
export var adapterProperties = function adapterProperties(values, adapter) {
  var adapterPrefix = "".concat(adapter, "_");
  var properties = values // Remove the other adapters properties.
  .filter(function (_v, key) {
    return key.startsWith(adapterPrefix);
  }) // Remove the adapter prefix from the property names.
  .mapKeys(function (key) {
    return key.replace(adapterPrefix, '');
  }).toObject();
  return properties;
};
export var propertiesFromAdapters = function propertiesFromAdapters() {
  var taskDbAdapters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : List();
  var typeKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'type';
  return taskDbAdapters.flatMap(function (adapter) {
    return adapter.get('properties', List()).map(function (property) {
      return property.set('type', adapter.get(typeKey));
    });
  });
};
export var propertiesFromValues = function propertiesFromValues(values) {
  var adapterType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'type';
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var adapterTypeName = formPropertyName(prefix, adapterType);
  var propertiesType = formPropertyName(prefix, 'properties', values.get(adapterTypeName));
  return values.filter(function (value, name) {
    return name.startsWith(propertiesType);
  }).mapKeys(function (name) {
    return name.replace("".concat(propertiesType, "_"), '');
  });
};
export var formPropertyName = function formPropertyName() {
  for (var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++) {
    names[_key] = arguments[_key];
  }

  return names.filter(function (n) {
    return n !== '';
  }).join('_');
};

var getPropertyValue = function getPropertyValue(property, adapter, adapterType) {
  var defaultType = get(adapter, adapterType, null);
  var type = property.get('type');
  var propertyValue = property.get('value', '') || '';

  if (defaultType && defaultType === type) {
    var defaultProperty = adapter.getIn(['properties', property.get('name')], null);
    return defaultProperty || propertyValue || '';
  } else {
    return propertyValue;
  }
};

export var adapterPropertiesFields = function adapterPropertiesFields(_ref9) {
  var adapterProperties = _ref9.adapterProperties,
      defaultAdapter = _ref9.defaultAdapter,
      _ref9$prefix = _ref9.prefix,
      prefix = _ref9$prefix === void 0 ? '' : _ref9$prefix,
      _ref9$adapterType = _ref9.adapterType,
      adapterType = _ref9$adapterType === void 0 ? 'type' : _ref9$adapterType;
  return adapterProperties.map(function (property) {
    return {
      name: formPropertyName(prefix, 'properties', property.get('type'), property.get('name')),
      label: property.get('label') || property.get('name'),
      visible: function visible(_ref10) {
        var values = _ref10.values;
        return values.get(formPropertyName(prefix, adapterType)) === property.get('type');
      },
      type: property.get('sensitive') ? 'password' : property.has('options') ? 'select' : 'text',
      helpText: property.get('description'),
      required: function required(_ref11) {
        var values = _ref11.values;
        return values.get(formPropertyName(prefix, adapterType)) === property.get('type') && property.get('required', false);
      },
      options: property.get('options', undefined),
      initialValue: getPropertyValue(property, defaultAdapter, adapterType)
    };
  });
};